<template>
  <div>
    <Main
      :height="height"
      :loading="loading"
      :tableData="tableData"
      :type="type"
      ref="tableMain"
    >
      <Header ref="tableHeader" slot="header" @query="getData" />
    </Main>
  </div>
</template>
<script>
import Main from './main.vue'
import Header from './header.vue'
export default {
  components: { Main, Header },
  props: {
    height: { type: Number, default: 300 },
    shipmentCode: { type: String, default: '' },
    type: { type: String, default: 'radio' },
    data: { type: Array, default: () => [] },
  },
  data() {
    return {
      loading: false,
      tableData: [],
    }
  },
  methods: {
    getData(form) {
      if (!this.shipmentCode) return
      this.loading = true
      this.$api
        .shipmentBookingChooseContainerListApi({
          shipmentCode: this.shipmentCode,
          ...form,
        })
        .then((res) => {
          this.loading = false
          if (!this.data || this.data.length === 0) {
            this.tableData = res.body.data
            return
          }
          this.tableData = res.body.data.filter(
            (i) =>
              this.data.findIndex(
                (j) => j.shipmentContainerCode === i.shipmentContainerCode
              ) < 0
          )
        })
    },
    choiceData() {
      return this.$refs.tableMain.choiceData()
    },
  },
}
</script>
